import styled from '@emotion/styled';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';

import { Dialog } from '@/components/shared/components/Dialog';
import { SupportContactMessage } from '@/components/shared/components/SupportContactMessage';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 8px 0;
`;

const Message = styled.p`
    margin: 0;
    color: #6b7280;
    font-size: 13px;
`;

const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

export const ServerOutageDialog = ({ visible }: { visible: boolean }) => {
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (!visible) setDismissed(false);
    }, [visible]);

    return (
        <Dialog
            id="server-outage-modal"
            header="Server Unavailable"
            visible={visible && !dismissed}
            onHide={() => setDismissed(true)}
            data-testid="server-outage-dialog"
        >
            <Container>
                <Message data-testid="server-outage-message">
                    <SupportContactMessage
                        lead="We can't reach the server right now, so some information may be missing or out of date."
                        copyLinkTestId="server-outage-copy-orp-link-button"
                    />
                </Message>
                <Actions>
                    <Button
                        label="Dismiss"
                        severity="secondary"
                        outlined
                        onClick={() => setDismissed(true)}
                        data-testid="server-outage-dismiss"
                    />
                    <Button
                        label="Refresh Page"
                        severity="info"
                        onClick={() => window.location.reload()}
                        data-testid="server-outage-refresh"
                    />
                </Actions>
            </Container>
        </Dialog>
    );
};
